import { render, staticRenderFns } from "./homeworkInfo.vue?vue&type=template&id=427f3a4a&scoped=true&"
import script from "./homeworkInfo.vue?vue&type=script&lang=js&"
export * from "./homeworkInfo.vue?vue&type=script&lang=js&"
import style0 from "./homeworkInfo.vue?vue&type=style&index=0&id=427f3a4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f3a4a",
  null
  
)

export default component.exports